import { render, staticRenderFns } from "./OrganizationCard.vue?vue&type=template&id=805d61ca&scoped=true&"
import script from "./OrganizationCard.vue?vue&type=script&lang=js&"
export * from "./OrganizationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805d61ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('805d61ca')) {
      api.createRecord('805d61ca', component.options)
    } else {
      api.reload('805d61ca', component.options)
    }
    module.hot.accept("./OrganizationCard.vue?vue&type=template&id=805d61ca&scoped=true&", function () {
      api.rerender('805d61ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/organization/OrganizationCard.vue"
export default component.exports